"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFileErrorMessageIdByStatus = void 0;

var getFileErrorMessageIdByStatus = function getFileErrorMessageIdByStatus(errorStatus) {
  switch (errorStatus) {
    case 403:
      return 'actionNotAllowed';

    case 404:
      return 'fileNotFound';

    case 500:
      return 'serverError';
  }
};

exports.getFileErrorMessageIdByStatus = getFileErrorMessageIdByStatus;